import { useState } from "react"

import { useAppContext } from "providers/AppProvider/AppProvider"
import { useUI } from "providers/UIProvider"

import CompanyBranchesCount from "./CompanyBranchesCount"
import { Box, Flex, Image, Text, Spinner } from "@chakra-ui/react"
import Dropdown from "components/UI/atoms/Dropdown"
import Icon from "components/UI/atoms/Icon"
import useCompanyBranches from "hooks/useCompanyBranches"
import { IRoles } from "types/shared"
import { useReportsContext } from "providers/ReportsProvider/ReportsProvider"

interface props {
    width?: string
}

const CompanyBranchesForReports = ({ width = "306px" }: props) => {
    const { T } = useUI()
    const { branchesSearchValue, updateBranchesSearchValue, userRole } = useAppContext()
    const { selectedBranchesForReports, updateSelectedBranchesForReports } = useReportsContext()
    const { singleLaundry, laundryBranchesDataLoading, branchOptions, selectAll, setSelectAll } = useCompanyBranches()
    const [dropdownOpened, toggleDropdown] = useState<boolean>(false)
    const handleSelectAll = () => {
        if (selectAll) {
            setSelectAll(false)
            updateSelectedBranchesForReports([])
        } else {
            setSelectAll(true)
            updateSelectedBranchesForReports(branchOptions.map((item: any) => item.id))
        }

        toggleDropdown(false)
    }
    const handleSelectItem = (val: number) => {
        let updatedSelectedBranches = []
        let updatedSelectAll = selectAll

        if (selectedBranchesForReports.includes(val)) {
            updatedSelectedBranches = selectedBranchesForReports.filter((item) => item !== val)
        } else {
            updatedSelectedBranches = [...selectedBranchesForReports, val]
        }

        if (updatedSelectedBranches.length === branchOptions.length) {
            updatedSelectAll = true
        } else {
            updatedSelectAll = false
        }

        updateSelectedBranchesForReports(updatedSelectedBranches)
        setSelectAll(updatedSelectAll)

    }

    const selectedBranch = selectedBranchesForReports?.length === 1 && branchOptions.find((branchOption) => branchOption.id && selectedBranchesForReports.includes(branchOption.id)) || null
    const logoUrl = singleLaundry?.logoUrl || selectedBranch?.leftImg
    const title = singleLaundry?.name ? `${singleLaundry?.name} ${singleLaundry?.address}` : selectedBranch?.label

    const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);

    return (
        <Box position="relative" width="306px" height="58px">
            {selectedBranchesForReports?.length > 1 && (
                <CompanyBranchesCount
                    count={selectedBranchesForReports.length}
                    onClick={() => toggleDropdown(true)}
                    dropdownOpened={dropdownOpened}
                    selectedAll={selectAll}
                />
            )}
            {selectedBranchesForReports?.length < 2 && (
                <Box
                    width={width}
                    height="58px"
                    as="button"
                    backgroundColor="white"
                    borderRadius="base"
                    borderBottomRadius={dropdownOpened ? "0" : "base"}
                    pointerEvents={dropdownOpened ? "none" : "auto"}
                    boxShadow="primary"
                    fontSize="base"
                    fontFamily="heading"
                    padding="0 15px"
                    onClick={() => toggleDropdown(true)}
                >
                    <Flex width="100%" height="100%" alignItems="center" justifyContent="space-between">
                        <Flex alignItems="center" >
                            {isQappUser && selectedBranchesForReports.length > 0 && <Image src={logoUrl} alt="Company" width="45px" />}
                            {!isQappUser && <Image src={logoUrl} alt="Company" width="45px" />}
                            <Text ml="10px" mr="10px" fontWeight="bold">
                                {isQappUser && (selectedBranchesForReports.length > 0 ? title : T("general.select_branches"))}
                                {!isQappUser && title}
                            </Text>
                        </Flex>
                        {isQappUser && laundryBranchesDataLoading && <Spinner />}

                        {isQappUser && <Icon name="dropdown" iconStyles={{ fill: "#00000" }} />}
                    </Flex>
                </Box>
            )}
            {isQappUser && (
                <Dropdown
                    height="25rem"
                    selectable
                    selectAll={selectAll}
                    handleSelectItem={handleSelectItem}
                    handleSelectAll={handleSelectAll}
                    searchable
                    selected={selectedBranch?.id?.toString()}
                    selectedItems={selectedBranchesForReports}
                    searchValue={branchesSearchValue}
                    onSearch={(val) => updateBranchesSearchValue(val)}
                    searchPlaceholder={T("general.search_for_company")}
                    opened={dropdownOpened}
                    toggleOpened={toggleDropdown}
                    items={branchOptions}
                    styles={{
                        top: "59px",
                        fontWeight: "bold",
                    }}
                />
            )}
        </Box>
    )
}

export default CompanyBranchesForReports
